import { render, staticRenderFns } from "./textareaInput.vue?vue&type=template&id=37300b97&scoped=true&"
import script from "./textareaInput.vue?vue&type=script&lang=ts&"
export * from "./textareaInput.vue?vue&type=script&lang=ts&"
import style0 from "./textareaInput.vue?vue&type=style&index=0&id=37300b97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37300b97",
  null
  
)

export default component.exports